import React from 'react';

const ContentTitle = ({ children, className }) => (
  <h1 className={`promos promos-title ${className || ''}`}>{children}</h1>
);

export default ContentTitle;
